import { useEffect } from "react";
import { useSelector } from "react-redux";

import { pushDataLayerWithClientBuildUnixTime } from "./ga";
import { createEcommerceEventItemName } from "./gtmEventModel";

import type { EcommerceEventItem } from "./gtmEventModel";
import type { ProductType } from "@spwn/types";
import type { Cart, Product } from "hooks/cart/Cart";
import type { MyCartData } from "modules/cart";
import type { Store } from "store";

const checkIfTicketOrGoods = (
  product: Product,
  myCarts: MyCartData[]
): ProductType => {
  for (const myCart of myCarts) {
    const foundTicket = myCart.tickets.find(
      (ticket) => ticket.productId === product.id
    );
    if (foundTicket) {
      return "ticket";
    }

    const foundGoods = myCart.goods.find(
      (ticket) => ticket.productId === product.id
    );
    if (foundGoods) {
      return "goods";
    }
  }

  // ここに来ることはないはずだが、型checkのため
  return "ticket";
};
const getEventIdOfItem = (product: Product, myCarts: MyCartData[]) => {
  const myCart = myCarts.find((myCart) => {
    const foundTicket = myCart.tickets.find(
      (ticket) => ticket.productId === product.id
    );
    if (foundTicket) {
      return true;
    }

    const foundGoods = myCart.goods.find(
      (ticket) => ticket.productId === product.id
    );
    if (foundGoods) {
      return true;
    }

    return false;
  });

  if (myCart) {
    return myCart.eventId;
  }

  return "";
};

export const usePushViewCartEventToGA = (cart: Cart): void => {
  const myCart = useSelector((state: Store) => state.cart.myCart);

  useEffect(() => {
    const totalPrice = cart.orderCarts.reduce(
      (acc, cart) => acc + cart.subTotalPrice,
      0
    );

    const items: EcommerceEventItem[] = cart.orderCarts.flatMap((cart) => {
      return cart.products.map((product) => {
        const eventId = getEventIdOfItem(product, myCart);
        return {
          item_name: createEcommerceEventItemName({
            itemName: product.name,
            eventId,
          }),
          item_id: product.id,
          item_category: checkIfTicketOrGoods(product, myCart),
          item_list_id: eventId,
          price: product.price,
          quantity: product.count,
        };
      });
    });

    pushDataLayerWithClientBuildUnixTime({
      event: "view_cart",
      ecommerce: { currency: "JPY", value: totalPrice, items },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const usePushViewItemEventToGA = (items: EcommerceEventItem[]): void => {
  const sumOfPrice = items.reduce((acc, item) => acc + item.price, 0);

  useEffect(() => {
    if (items.length === 0 || sumOfPrice === undefined) {
      return;
    }

    // setTimeoutを使用して、debounce実装
    const timeoutId = setTimeout(() => {
      pushDataLayerWithClientBuildUnixTime({
        event: "view_item",
        ecommerce: { currency: "JPY", value: sumOfPrice, items },
      });
    }, 5000);

    return () => {
      // クリーンアップ関数でタイマーをクリア
      clearTimeout(timeoutId);
    };
  }, [sumOfPrice, items]);
};
